import {
    STATISTICS_CALENDAR_ROUTE,
    STATISTICS_CALENDAR_SUCCESS
} from './constants';

/**
 *
 * @param calendarID
 * @returns {{calendarID: *, type: string}}
 */
const statisticsCalendar = calendarID => ({
  type: STATISTICS_CALENDAR_ROUTE,
  calendarID
});

/**
 *
 * @param statistics
 * @returns {{type: string, statistics: *}}
 */
const statisticsCalendarSuccess = statistics => {
  return ({
    type: STATISTICS_CALENDAR_SUCCESS,
    statistics
});};

export {
    statisticsCalendar,
    statisticsCalendarSuccess
};
